import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=6ba0c467&scoped=true&"
import script from "./Insights.vue?vue&type=script&lang=js&"
export * from "./Insights.vue?vue&type=script&lang=js&"
import style0 from "./Insights.vue?vue&type=style&index=0&id=6ba0c467&lang=stylus&scoped=true&"
import style1 from "./Insights.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0c467",
  null
  
)

export default component.exports